/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { BackfillShareEventsRequestBuilderRequestsMetadata, type BackfillShareEventsRequestBuilder } from './backfillShareEvents/index.js';
// @ts-ignore
import { type WithMessageItemRequestBuilder, WithMessageItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { SendRequestBuilderRequestsMetadata, type SendRequestBuilder } from './send/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/messagecenter/carts
 */
export interface CartsRequestBuilder extends BaseRequestBuilder<CartsRequestBuilder> {
    /**
     * The backfillShareEvents property
     */
    get backfillShareEvents(): BackfillShareEventsRequestBuilder;
    /**
     * The send property
     */
    get send(): SendRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.messagecenter.carts.item collection
     * @param messageId Unique identifier of the item
     * @returns {WithMessageItemRequestBuilder}
     */
     byMessageId(messageId: string) : WithMessageItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CartsRequestBuilderUriTemplate = "{+baseurl}/api/messagecenter/carts";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CartsRequestBuilderNavigationMetadata: Record<Exclude<keyof CartsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byMessageId: {
        requestsMetadata: WithMessageItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["messageId"],
    },
    backfillShareEvents: {
        requestsMetadata: BackfillShareEventsRequestBuilderRequestsMetadata,
    },
    send: {
        requestsMetadata: SendRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
